<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <!-- <Form ref="queryForm" :label-width="90" label-position="right" inline>
          <Row :gutter="16">
            <Col span="4">
            <FormItem label="名称:" :label-width="70" style="width: 100%">
              <Input v-model="params.name" placeholder="请输入名称"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="编码:" :label-width="70" style="width: 100%">
              <Input v-model="params.code" placeholder="请输入编码"></Input>
            </FormItem>
            </Col>

            <Button icon="ios-search" type="primary" size="default" @click="queryTab()" class="toolbar-btn">{{ '查询' }}</Button>
            <Button @click="addSupper" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '添加' }}</Button>
          </Row>
        </Form> -->
        <div v-if="list">
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <new-supper :value="createShow" :isAddGYS="isAddGYS" :isAdd="isAdd" @close="close" :id="itemId" @getTab="getTab" />
    <!-- v-if是为了解决初始化不发请求 -->
    <QRCode :value="modalShow" @close="closeQR" :id="itemId" v-if="modalShow && itemId" />
  </div>
</template>

<script>
import NewSupper from './newSupper.vue'
import QRCode from './QRCode.vue'
import Util from '../../../lib/util'
export default {
  name: 'supplierBMCL',
  data() {
    return {
      list: [],
      itemId: 0,
      params: {
        name: '',
        code: '',
        IncludeCreatoUser: true,
        SkipCount: 0,
        MaxResultCount: 10,
        supplierTypes: '表面处理供应商',
      },
      totalCount: 0,
      currentPage: 1,
      loading: false,
      createShow: false,
      isAddGYS: false,
      isAdd: true,
      columns: [],
      modalShow: false,
      QRImg: '',
    }
  },
  components: {
    NewSupper,
    QRCode,
  },
  mounted() {
    this.getTab()
    this.getColumns()
  },
  methods: {
    //获取表格数据
    async getTab() {
      const data = await this.$Ajax.get('/api/services/app/Supplier/QueryDto', {
        params: this.params,
      })
      console.log(data)
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
    },
    //查询
    queryTab() {
      this.params.SkipCount = 0
      this.currentPage = 1
      this.$nextTick(() => {})
      this.getTab()
    },
    addSupper() {
      this.isAdd = true
      this.isAddGYS = false
      this.createShow = true
    },
    //分页
    pageChange(size) {
      this.params.SkipCount = (size - 1) * this.params.MaxResultCount
      this.getTab()
    },
    pagesizeChange(size) {
      this.params.MaxResultCount = size
      this.getTab()
    },
    //关闭弹框
    close() {
      this.createShow = false
    },
    closeQR(val) {
      this.modalShow = val
    },
    //表格
    getColumns() {
      let _this = this
      this.columns = [
        {
          title: '编码',
          key: 'code',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '微信openID',
          key: 'wxOpenId',
        },
        {
          title: '登录账号',
          key: 'usernane',
          render: (h, params) => {
            return h('span', params.row.bindUser.userName)
          },
        },
        {
          title: '供应商类型',
          key: 'supplierType',
        },
        {
          title: '是否核心供应商',
          key: 'isCoreSupplierText',
        },
        {
          title: '创建时间',
          key: 'creationTimeText',
          // render:(h,params) => {
          //     return h("span", params.row.selectItem.name)
          // }
        },
        {
          title: '创建人',
          key: 'writtenUser',
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '操作',
          align: 'left',
          width: 250,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.is采购部员工 ? 'none' : 'inline-block',
                  },
                  on: {
                    click: () => {
                      _this.itemId = params.row.id
                      console.log(
                        '🚀 ~ file: supplier.vue ~ line 143 ~ getColumns ~ _this.itemId',
                        _this.itemId
                      )
                      _this.isAdd = false

                      if (params.row.userId == null) {
                        //已有人员，为他新增账号
                        _this.isAddGYS = true
                      } else {
                        _this.isAddGYS = false
                      }

                      _this.createShow = true
                    },
                  },
                },
                params.row.userId != null ? ' 编辑' : '新增账号'
              ),

              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isNeedAddNewUser ? 'none' : 'inline-block',
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确定重置密码？',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.post(
                            '/api/services/app/Supplier/ResetPasswordBySupplier?userId=' +
                              params.row.userId
                          )
                          if (res.data.success) {
                            this.$Message.success({
                              content: res.data.result.message,
                              background: true,
                              duration: 15,
                            })
                          } else {
                            this.$Message.success('重置失败')
                          }
                          this.getTab()
                        },
                      })
                    },
                  },
                },
                '重置密码'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    display: params.row.is采购部员工 ? 'none' : 'inline-block',
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: '确定删除数据？',
                        content: '删除后不可撤销',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.delete(
                            '/api/services/app/Supplier/DeleteSupplierUserAndSupplier',
                            {
                              params: { supplierId: params.row.id },
                            }
                          )
                          if (res.data.success) {
                            this.$Message.success('删除成功')
                          } else {
                            this.$Message.success('删除失败')
                          }
                          this.getTab()
                        },
                      })
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ]
    },
  },
}
</script>

<style scoped>
.app {
  min-width: 1260px;
}
</style>
